/*
 * @Author: yanyongchao
 * @Date: 2019-01-01 18:50:56
 */
import { Toast } from 'fs-ui'
import setupWebViewJavascriptBridge from './js-bridge'
(function() {
  let temp

  setupWebViewJavascriptBridge(bridge => {
    bridge.registerHandler('notifyJsShowLoading', (res) => {
      if (res === '0') {
        if (temp) temp = null
        temp = new Toast({
          type: 'loading',
          message: '压缩中...',
          duration: 0,
          overlay: true
        })
      } else {
        temp.value = false
        temp = null
      }
    })
  })
})()
